import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { signOutUser } from '@/services/auth';
import Button from '@/components/UI/Button';
import HeatLogo from '@/components/UI/HeatLogo';
import { MobileNavigationDrawer } from './MobileNavigation';
import { User, LogOut } from 'lucide-react';

export default function Header() {
  const { userProfile } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOutUser();
    } catch (error) {
      // Sign out errors are typically handled by the auth service
      // and will redirect to login page regardless
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 fixed top-0 left-0 right-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Mobile Navigation + Logo */}
          <div className="flex items-center space-x-3">
            <MobileNavigationDrawer />
            <div className="flex items-center space-x-3">
              <HeatLogo className="h-8 w-auto" />
              <div>
                <h1 className="text-xl font-bold text-gray-900">Heat.Coach</h1>
                <p className="text-xs text-gray-600 -mt-1 hidden sm:block">Healthy Extreme Athletics Training AI Coach</p>
              </div>
            </div>
          </div>

          {/* User menu */}
          <div className="flex items-center space-x-4">
            {userProfile && (
              <div className="hidden sm:flex items-center space-x-2">
                <User className="w-5 h-5 text-gray-400" />
                <span className="text-sm text-gray-700">
                  {userProfile.name}
                </span>
              </div>
            )}
            
            <div className="flex items-center space-x-2">
              <Button
                variant="ghost"
                size="sm"
                onClick={handleSignOut}
                className="flex items-center space-x-1"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Sign Out</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
